const sk = {
  auth: {
    login: 'Prihlásiť sa',
    loggingIn: 'Prihlasovanie...',
    loginWithNetlifyIdentity: 'Prihlásiť sa cez Netlify Identity',
    loginWithAzure: 'Prihlásiť sa cez Azure',
    loginWithBitbucket: 'Prihlásiť sa cez Bitbucket',
    loginWithGitHub: 'Prihlásiť sa cez GitHub',
    loginWithGitLab: 'Prihlásiť sa cez GitLab',
    loginWithGitea: 'Prihlásiť sa cez Gitea',
    errors: {
      email: 'Nezabudnite zadať svoj e-mail.',
      password: 'Zadajte svoje heslo.',
      identitySettings: 'Nedá sa získať prístup k nastaveniam identity. Ak používate server git-gateway, uistite sa, že máte povolenú službu Identity a Git Gateway.'
    }
  },
  app: {
    header: {
      content: 'Obsah',
      workflow: 'Redakčný proces',
      media: 'Médiá',
      quickAdd: 'Rýchle pridanie'
    },
    app: {
      errorHeader: 'Chyba pri načítaní konfigurácie redakčného systému',
      configErrors: 'Chyby konfigurácie',
      checkConfigYml: 'Skontrolujte svoj súbor config.yml.',
      loadingConfig: 'Načítava sa konfigurácia...',
      waitingBackend: 'Čaká sa na server...'
    },
    notFoundPage: {
      header: 'Nenájdené'
    }
  },
  collection: {
    sidebar: {
      collections: 'Kolekcie',
      allCollections: 'Všetky kolekcie',
      searchAll: 'Hľadať všade',
      searchIn: 'Hľadať v'
    },
    collectionTop: {
      sortBy: 'Zoradiť podľa',
      viewAs: 'Zobraziť ako',
      viewAsList: 'Zobraziť ako zoznam',
      viewAsGrid: 'Zobraziť ako mriežku',
      newButton: '＋ %{collectionLabel}',
      newButtonAriaLabel: 'Vytvoriť záznam typu %{collectionLabel}',
      ascending: 'Vzostupne',
      descending: 'Zostupne',
      searchResults: 'Výsledky vyhľadávania pre „%{searchTerm}“',
      searchResultsInCollection: 'Výsledky vyhľadávania pre „%{searchTerm}“ v sekcii %{collection}',
      filterBy: 'Filtrovať podľa',
      groupBy: 'Zoskupiť podľa'
    },
    entries: {
      loadingEntries: 'Načítavajú sa záznamy...',
      cachingEntries: 'Záznamy sa ukladajú do vyrovnávacej pamäte...',
      longerLoading: 'Môže to trvať niekoľko minút',
      noEntries: 'Žiadne záznamy'
    },
    groups: {
      other: 'Ostatné',
      negateLabel: 'Nie je %{label}'
    },
    defaultFields: {
      author: {
        label: 'Autor'
      },
      updatedOn: {
        label: 'Aktualizované'
      }
    }
  },
  editor: {
    editorControl: {
      field: {
        optional: 'voliteľné',
        widgetLabel: 'Pole %{widgetLabel}'
      }
    },
    editorControlPane: {
      widget: {
        required: 'Pole %{fieldLabel} je povinné.',
        regexPattern: 'Pole %{fieldLabel} nezodpovedá vzoru: %{pattern}.',
        processing: 'Pole %{fieldLabel} sa spracováva.',
        range: 'Pole %{fieldLabel} musí byť medzi %{minValue} a %{maxValue}.',
        min: 'Pole %{fieldLabel} musí mať aspoň %{minValue}.',
        max: 'Pole %{fieldLabel} musí mať %{maxValue} alebo menej.',
        rangeCount: 'Pole %{fieldLabel} musí mať od %{minCount} do %{maxCount} položiek.',
        rangeCountExact: 'Pole %{fieldLabel} musí mať presne %{count} položiek.',
        rangeMin: 'Pole %{fieldLabel} musí mať aspoň %{minCount} položiek.',
        rangeMax: 'Pole %{fieldLabel} musí mať najviac %{maxCount} položiek.',
        invalidPath: 'Cesta „%{path}“ nie je platná',
        pathExists: 'Cesta „%{path}“ už existuje'
      },
      i18n: {
        writingInLocale: 'Píše sa v jazyku %{locale}',
        copyFromLocale: 'Vyplniť z iného jazyka',
        copyFromLocaleConfirm: 'Chcete vyplniť údaje z jazyka %{locale}?\nVšetok existujúci obsah bude prepísaný.'
      }
    },
    editor: {
      onLeavePage: 'Naozaj chcete opustiť túto stránku?',
      onUpdatingWithUnsavedChanges: 'Máte neuložené zmeny, pred aktualizáciou stavu ich prosím uložte.',
      onPublishingNotReady: 'Pred publikovaním aktualizujte stav na „Pripravené“.',
      onPublishingWithUnsavedChanges: 'Máte neuložené zmeny, pred publikovaním ich prosím uložte.',
      onPublishing: 'Naozaj chcete publikovať tento záznam?',
      onUnpublishing: 'Naozaj chcete zrušiť publikovanie tohto záznamu?',
      onDeleteWithUnsavedChanges: 'Naozaj chcete vymazať tento publikovaný záznam, ako aj neuložené zmeny z aktuálnej relácie?',
      onDeletePublishedEntry: 'Naozaj chcete vymazať tento publikovaný záznam?',
      onDeleteUnpublishedChangesWithUnsavedChanges: 'Týmto sa vymažú všetky nepublikované zmeny tohto záznamu, ako aj vaše neuložené zmeny z aktuálnej relácie. Stále chcete záznam vymazať?',
      onDeleteUnpublishedChanges: 'Všetky nepublikované zmeny tohto záznamu budú vymazané. Stále chcete záznam vymazať?',
      loadingEntry: 'Načítava sa záznam...',
      confirmLoadBackup: 'Pre tento záznam bola obnovená lokálna záloha, chcete ju použiť?'
    },
    editorInterface: {
      toggleI18n: 'Prepnúť lokalizáciu',
      togglePreview: 'Prepnúť náhľad',
      toggleScrollSync: 'Synchronizovať posúvanie'
    },
    editorToolbar: {
      publishing: 'Publikuje sa...',
      publish: 'Publikovať',
      published: 'Publikované',
      unpublish: 'Zrušiť publikovanie',
      duplicate: 'Duplikovať',
      unpublishing: 'Ruší sa publikovanie...',
      publishAndCreateNew: 'Publikovať a vytvoriť nový',
      publishAndDuplicate: 'Publikovať a duplikovať',
      deleteUnpublishedChanges: 'Vymazať nepublikované zmeny',
      deleteUnpublishedEntry: 'Vymazať nepublikovaný záznam',
      deletePublishedEntry: 'Vymazať publikovaný záznam',
      deleteEntry: 'Vymazať záznam',
      saving: 'Ukladá sa...',
      save: 'Uložiť',
      statusInfoTooltipDraft: 'Stav záznamu je nastavený na koncept. Pre jeho dokončenie a odoslanie na kontrolu nastavte stav na „Na posúdenie“.',
      statusInfoTooltipInReview: 'Záznam sa posudzuje, nie sú potrebné žiadne ďalšie kroky. Počas kontroly však stále môžete vykonávať ďalšie zmeny.',
      deleting: 'Vymazáva sa...',
      updating: 'Aktualizuje sa...',
      status: 'Stav: %{status}',
      backCollection: ' Píše sa v kolekcii %{collectionLabel}',
      unsavedChanges: 'Neuložené zmeny',
      changesSaved: 'Zmeny uložené',
      draft: 'Koncept',
      inReview: 'Na posúdenie',
      ready: 'Pripravené',
      publishNow: 'Publikovať teraz',
      deployPreviewPendingButtonLabel: 'Skontrolovať náhľad',
      deployPreviewButtonLabel: 'Zobraziť náhľad',
      deployButtonLabel: 'Zobraziť ostrú verziu'
    },
    editorWidgets: {
      markdown: {
        bold: 'Tučné',
        italic: 'Kurzíva',
        strikethrough: 'Prečiarknuté',
        code: 'Kód',
        link: 'Odkaz',
        linkPrompt: 'Zadajte URL adresu odkazu',
        headings: 'Nadpisy',
        quote: 'Citát',
        bulletedList: 'Zoznam s odrážkami',
        numberedList: 'Číslovaný zoznam',
        addComponent: 'Pridať komponent',
        richText: 'Formátovaný text',
        markdown: 'Markdown',
        toggleMode: {
          rich: 'Prepnúť do režimu formátovaného textu',
          markdown: 'Prepnúť do režimu Markdown'
        }
      },
      image: {
        choose: 'Vybrať obrázok',
        chooseMultiple: 'Vybrať obrázky',
        chooseUrl: 'Vložiť z URL',
        replaceUrl: 'Nahradiť pomocou URL',
        promptUrl: 'Zadajte URL adresu obrázka',
        chooseDifferent: 'Vybrať iný obrázok',
        addMore: 'Pridať ďalšie obrázky',
        remove: 'Odstrániť obrázok',
        removeAll: 'Odstrániť všetky obrázky'
      },
      file: {
        choose: 'Vybrať súbor',
        chooseUrl: 'Vložiť z URL',
        chooseMultiple: 'Vybrať súbory',
        replaceUrl: 'Nahradiť pomocou URL',
        promptUrl: 'Zadajte URL adresu súboru',
        chooseDifferent: 'Vybrať iný súbor',
        addMore: 'Pridať ďalšie súbory',
        remove: 'Odstrániť súbor',
        removeAll: 'Odstrániť všetky súbory'
      },
      unknownControl: {
        noControl: 'Žiadny ovládací prvok pre komponent „%{widget}“.'
      },
      unknownPreview: {
        noPreview: 'Žiadny náhľad pre komponent „%{widget}“.'
      },
      headingOptions: {
        headingOne: 'Nadpis 1',
        headingTwo: 'Nadpis 2',
        headingThree: 'Nadpis 3',
        headingFour: 'Nadpis 4',
        headingFive: 'Nadpis 5',
        headingSix: 'Nadpis 6'
      },
      datetime: {
        now: 'Teraz',
        clear: 'Vymazať',
        setToNow: 'Nastaviť %{fieldLabel} na teraz'
      },
      list: {
        add: 'Pridať %{item}',
        addType: 'Pridať %{item}'
      },
      object: {
        expand: 'Rozbaliť',
        collapse: 'Zbaliť'
      }
    }
  },
  mediaLibrary: {
    mediaLibraryCard: {
      draft: 'Koncept',
      copy: 'Kopírovať',
      copyUrl: 'Kopírovať URL',
      copyPath: 'Kopírovať cestu',
      copyName: 'Kopírovať názov',
      copied: 'Skopírované'
    },
    mediaLibrary: {
      onDelete: 'Naozaj chcete vymazať vybrané médiá?',
      fileTooLarge: 'Súbor je príliš veľký.\nNastavenia nedovoľujú súbory väčšie ako %{size} kB.'
    },
    mediaLibraryModal: {
      loading: 'Načítava sa...',
      close: 'Zavrieť',
      noResults: 'Žiadne výsledky.',
      noAssetsFound: 'Nenašli sa žiadne súbory.',
      noImagesFound: 'Nenašli sa žiadne obrázky.',
      private: 'Súkromné ',
      images: 'Obrázky',
      mediaAssets: 'Mediálne súbory',
      search: 'Hľadať...',
      uploading: 'Nahráva sa...',
      upload: 'Nahrať',
      download: 'Stiahnuť',
      deleting: 'Vymazáva sa...',
      deleteSelected: 'Vymazať vybrané',
      chooseSelected: 'Zvoliť vybrané'
    }
  },
  ui: {
    default: {
      goBackToSite: 'Vrátiť sa na stránku'
    },
    errorBoundary: {
      title: 'Chyba',
      details: 'Vyskytla sa chyba - prosím ',
      reportIt: 'nahláste tento problém na GitHube.',
      detailsHeading: 'Podrobnosti',
      privacyWarning: 'Pri nahlásení problému sa automaticky predvyplní chybová správa a údaje pre ladenie.\nProsím, overte, či sú informácie správne a odstráňte prípadné citlivé údaje.',
      recoveredEntry: {
        heading: 'Obnovený dokument',
        warning: 'Pred odchodom zo stránky si toto niekam skopírujte alebo vložte!',
        copyButtonLabel: 'Kopírovať do schránky'
      }
    },
    settingsDropdown: {
      logOut: 'Odhlásiť sa',
      account: 'Rozbaľovacia ponuka možností účtu'
    },
    toast: {
      onFailToLoadEntries: 'Nepodarilo sa načítať záznam: %{details}',
      onFailToLoadDeployPreview: 'Nepodarilo sa načítať náhľad: %{details}',
      onFailToPersist: 'Nepodarilo sa uložiť záznam: %{details}',
      onFailToDelete: 'Nepodarilo sa vymazať záznam: %{details}',
      onFailToUpdateStatus: 'Nepodarilo sa aktualizovať stav: %{details}',
      missingRequiredField: 'Vynechali ste povinné pole. Pred uložením ho prosím vyplňte.',
      entrySaved: 'Záznam uložený',
      entryPublished: 'Záznam publikovaný',
      entryUnpublished: 'Publikovanie záznamu zrušené',
      onFailToPublishEntry: 'Nepodarilo sa publikovať: %{details}',
      onFailToUnpublishEntry: 'Nepodarilo sa zrušiť publikovanie záznamu: %{details}',
      entryUpdated: 'Stav záznamu bol aktualizovaný',
      onDeleteUnpublishedChanges: 'Nepublikované zmeny boli vymazané',
      onFailToAuth: '%{details}',
      onLoggedOut: 'Boli ste odhlásení, prosím zálohujte si akékoľvek dáta a znova sa prihláste',
      onBackendDown: 'Serverová služba zaznamenala výpadok. Pre viac informácií si pozrite %{details}'
    }
  },
  workflow: {
    workflow: {
      loading: 'Načítavajú sa záznamy redakčného procesu',
      workflowHeading: 'Redakčný proces',
      newPost: 'Nový príspevok',
      description: '%{smart_count} záznam čaká na posúdenie, %{readyCount} pripravený na publikovanie. |||| %{smart_count} záznamy čakajú na posúdenie, %{readyCount} pripravené na publikovanie. |||| %{smart_count} záznamov čaká na posúdenie, %{readyCount} pripravených na publikovanie.',
      dateFormat: 'D. MMMM'
    },
    workflowCard: {
      lastChange: '%{date} - %{author}',
      lastChangeNoAuthor: '%{date}',
      lastChangeNoDate: 'od %{author}',
      deleteChanges: 'Vymazať zmeny',
      deleteNewEntry: 'Vymazať nový záznam',
      publishChanges: 'Publikovať zmeny',
      publishNewEntry: 'Publikovať nový záznam'
    },
    workflowList: {
      onDeleteEntry: 'Naozaj chcete vymazať tento záznam?',
      onPublishingNotReadyEntry: 'Môžu byť publikované iba položky so stavom „Pripravené“. Ak chcete povoliť publikovanie, potiahnite kartu do stĺpca „Pripravené“.',
      onPublishEntry: 'Naozaj chcete publikovať tento záznam?',
      draftHeader: 'Koncepty',
      inReviewHeader: 'Na posúdenie',
      readyHeader: 'Pripravené',
      currentEntries: '%{smart_count} záznam |||| %{smart_count} záznamy |||| %{smart_count} záznamov'
    }
  }
};
export default sk;